module.exports = __webpack_public_path__ + "img/lever03.b056d909.png";